export const tipoImovelTextRegistry = {
  apartamento: `Localizado no {ANDAR_AP} andar, com a(s) vaga(s) {VAGA_GARAGEM}, pertencente ao Condomínio {NOME_COND}, no município de {MUN_IMOVEL}, registrado sob matrícula nº {MAT_IMOVEL}, no {N_CARTORIO} Oficial de Registro de Imóveis de {MUN_CARTORIO}, sendo assim descrita e identificada como o “imóvel”.`,

  casa: `Imóvel localizado na {ENDERECO_IMOVEL}, nº {NUMERO_IMOVEL}, bairro {BAIRRO_IMOVEL}, município {MUN_IMOVEL}, área construída {AREA_CONSTRUIDA} m², terreno {AREA_TERRENO} m². Contendo {DESCRICAO_IMOVEL}, devidamente registrada sob a matrícula nº {MAT_IMOVEL}, no {N_CARTORIO} Oficial de Registro de Imóveis de {MUN_CARTORIO}, sendo assim descrita e identificada como o “imóvel”.`,

  galpao: `Localizado à {ENDERECO_IMOVEL}, bairro {BAIRRO_IMOVEL}, município {MUN_IMOVEL}, Estado {UF_IMOVEL}, área total {AREA_TOTAL} m². Constituído por galpão de fins comerciais, contendo {DESCRICAO_IMOVEL}, devidamente registrado sob a matrícula nº {MAT_IMOVEL}, no {N_CARTORIO} Oficial de Registro de Imóveis de {MUN_CARTORIO}, doravante descrito e identificado como o “imóvel”.`,

  lote: `Localizado à {ENDERECO_IMOVEL}, bairro {BAIRRO_IMOVEL}, município {MUN_IMOVEL}, Estado {UF_IMOVEL}, área total {AREA_TOTAL} m². Contendo {DESCRICAO_IMOVEL}, devidamente registrado sob a matrícula nº {MAT_IMOVEL}, no {N_CARTORIO} Oficial de Registro de Imóveis de {MUN_CARTORIO}, sendo assim descrito e identificado como o “imóvel”`,

  rural: `Localizado na {LOCALIDADE_IMOVEL}, município {MUN_IMOVEL}, Estado {UF_IMOVEL}, área total {AREA_TOTAL} {UNIDADE_AREA}. Contendo {DESCRICAO_IMOVEL}, devidamente registrado sob a matrícula nº {MAT_IMOVEL}, no {N_CARTORIO} Oficial de Registro de Imóveis de {MUN_CARTORIO}, cadastrado no INCRA sob o CCIR nº {CCIR_IMOVEL}, sendo assim descrito e identificado como o “imóvel”.`,

  salacomercial: `Localizada à {ENDERECO_IMOVEL}, no bairro {BAIRRO_IMOVEL}, no município de {MUN_IMOVEL}, Estado de {UF_IMOVEL}, com área total de {AREA_TOTAL} m², constituída por sala comercial, contendo {DESCRICAO_IMOVEL}, devidamente registrada sob a matrícula nº {MAT_IMOVEL}, no {N_CARTORIO} Oficial de Registro de Imóveis de {MUN_CARTORIO}, doravante descrita e identificada como o “imóvel”.`,
};

export const tipoIntermediador = {
  corretor: `
NOME: {NOME_CORRETOR}, NACIONALIDADE: {NACIONALIDADE_CORRETOR}, PROFISSÃO: CORRETOR DE IMÓVEIS, inscrito(a) no CPF sob nº {CPF_CORRETOR}, portador(a) do RG nº {RG_CORRETOR}, devidamente inscrito(a) no CRECI sob nº {CRECI_CORRETOR}, residente e domiciliado(a) no ENDEREÇO: {RUA_ENDERECO_CORRETOR}, nº {N_ENDERECO_CORRETOR}, BAIRRO {BAIRRO_ENDERECO_CORRETOR}, no município de {MUN_ENDERECO_CORRETOR} - CEP: {CEP_CORRETOR} EMAIL: {EMAIL_CORRETOR} TELEFONE: {TEL_CORRETOR}
`,

  imobiliaria: `
IMOBILIÁRIA: {RAZAO_SOCIAL_IMOBILIARIA} CNPJ: {CNPJ_IMOBILIARIA} CRECI: {CRECI_IMOBILIARIA}, neste ato representada por {NOME_REPRESENTANTE_LEGAL}, CPF: {CPF_REPRESENTANTE_LEGAL} ENDEREÇO: {RUA_ENDERECO_IMOBILIARIA}, nº {N_ENDERECO_IMOBILIARIA}, BAIRRO {BAIRRO_ENDERECO_IMOBILIARIA}, {MUN_ENDERECO_IMOBILIARIA} - CEP: {CEP_IMOBILIARIA} EMAIL: {EMAIL_IMOBILIARIA} TELEFONE: {TEL_IMOBILIARIA}

`,
}


export const usoLocacaoTextRegistry = {
  comercial: `comercial`,
  residencial: `residencial`,
  misto: `misto`,
};

export const clausulaGarantiaTextRegistry = {
  caucao: `Como garantia do fiel cumprimento das obrigações assumidas neste contrato, o LOCATÁRIO entrega ao LOCADOR, neste ato, a título de caução, o valor de R$ {VALOR_CAUCAO}, equivalente a {MESES_CAUCAO} meses de aluguel.
O valor da caução será devolvido ao LOCATÁRIO ao término da locação, após a efetiva entrega das chaves e verificação do cumprimento integral das obrigações contratuais, podendo ser utilizado para compensar eventuais débitos, tais como aluguéis em atraso, encargos, multas, danos ao imóvel ou quaisquer outros valores devidos.
`,
  fiador: `O(s) FIADOR(ES), devidamente qualificado(s) neste instrumento, assume(m) solidariamente com o LOCATÁRIO todas as obrigações decorrentes do presente contrato, responsabilizando-se pelo seu integral cumprimento, incluindo, mas não se limitando, ao pagamento de aluguéis, encargos, multas, tributos, indenizações e demais obrigações contratuais e legais.
A fiança ora prestada é concedida em caráter irrevogável e irretratável, estendendo-se até a efetiva devolução do imóvel, ainda que haja prorrogação da locação por prazo indeterminado, independentemente de anuência expressa do(s) FIADOR(ES).
O(s) FIADOR(ES) renuncia(m) expressamente aos benefícios de ordem, excussão e divisão, obrigando-se como principal(is) pagador(es), nos termos da legislação vigente.
`,
};


export const tipoPagamentoTextRegistry = {
  aprazo: `O preço ajustado para o presente contrato é de R$ {VALOR_TOTAL} ({VALOR_TOTAL_EXTENSO}), que será pago da seguinte forma:
I – Entrada: R$ {VALOR_ENTRADA}, paga em {FORMA_PAGAMENTO_ENTRADA} na data de {DATA_ENTRADA}.
II – O Saldo será pago da seguinte forma: {FORMA_PAGAMENTO_SALDO}.
III - O atraso no pagamento de qualquer parcela implicará multa de {PERCENTUAL_MULTA}%, além de juros de mora de {JUROS_MORA}% ao mês e correção monetária.`,

  avista: `Preço ajustado para o presente contrato é de R$ {VALOR_TOTAL} ({VALOR_TOTAL_EXTENSO}), que será pago integralmente à vista, em {FORMA_PAGAMENTO}, na data de {DATA_PAGAMENTO}.
No ato da assinatura deste instrumento, o(a) COMPRADOR(A) entrega ao(à) VENDEDOR(A), a título de arras confirmatórias, a quantia de R$ {VALOR_ARRAS} ({VALOR_ARRAS_EXTENSO}), a qual será considerada como parte integrante do preço acima ajustado.
O contrato produzirá plenos efeitos após a confirmação do efetivo recebimento do valor pelo(a) VENDEDOR(A).`,

  permuta: `O preço ajustado para o presente contrato é de R$ {VALOR_TOTAL} ({VALOR_TOTAL_EXTENSO}), sendo pago da seguinte forma:
I – O(a) COMPRADOR(A) entrega ao(à) VENDEDOR(A), a título de permuta, o bem descrito como {DESCRICAO_BEM_PERMUTA}, ao qual as partes atribuem o valor de R$ {VALOR_PERMUTA} ({VALOR_PERMUTA_EXTENSO}), livre e desembaraçado de ônus, conforme declarado.
II – O valor atribuído ao bem será abatido do preço total, restando o saldo de R$ {VALOR_SALDO} ({VALOR_SALDO_EXTENSO}), que será pago conforme abaixo descrito:
III - {FORMA_PAGAMENTO_SALDO}.
IV – O(a) COMPRADOR(A) declara ser legítimo(a) proprietário(a) do bem dado em permuta, responsabilizando-se por sua transferência, bem como por eventuais débitos, ônus ou evicção de direito.`,
};

export const tipoComissaoTextRegistry = {
  corretor: `
A intermediação deste negócio foi realizada pelo corretor {CORRETOR}, inscrito no CRECI nº {CRECI}, sendo ajustada entre as partes a comissão de corretagem no valor de {COMISSAO}, em razão da intermediação e conclusão do presente negócio.
`,

  imobiliaria: `
A intermediação deste negócio foi realizada pela imobiliária {IMOBILIARIA}, inscrita no CRECI nº {CRECI_IMOBILIARIA}, por meio do corretor {CORRETOR}, CRECI nº {CRECI_CORRETOR}, ficando ajustada entre as partes a comissão de corretagem no valor de {COMISSAO}, em razão da intermediação e conclusão do presente negócio.
`,
};

export const conjuge = {
  solteiro: "",

  casado:
    "CÔNJUGE: {NOME_CONJUGE} CPF: {CPF_CONJUGE} RG: {RG_CONJUGE} NACIONALIDADE: {NACIONALIDADE_CONJUGE} PROFISSÃO: {PROFISSAO_CONJUGE} EMAIL: {EMAIL_CONJUGE}, ambos residentes e domiciliados no:",

  divorciado: "",

  "viúvo": "",
};

const estadoCivilPessoaFisicaLabels = {
  solteiro: "Solteiro",
  casado: "Casado",
  divorciado: "Divorciado",
  "viúvo": "Viúvo",
};

export const estadoCivilPessoaFisicaOptions = Object.keys(conjuge).map(
  (value) => ({
    label: estadoCivilPessoaFisicaLabels[value] ?? value,
    value,
  })
);

/**
 * Display labels for the keys used in `type: "conditional"` sections of every form schema.
 * The keys themselves remain the canonical values stored in form state and sent to the
 * backend (`aprazo`, `avista`, `casa`, ...); these labels are only for the UI dropdown.
 *
 * Per-section overrides are still possible via `optionLabels` on the schema section
 * (e.g. when the same key needs a different label in a specific document).
 */
export const conditionalOptionLabels = {
  // tipo_imovel
  casa: "Casa",
  apartamento: "Apartamento",
  galpao: "Galpão",
  lote: "Lote",
  rural: "Rural",
  salacomercial: "Sala comercial",
  // tipo_pagamento
  aprazo: "A prazo",
  avista: "À vista",
  permuta: "Permuta",
  // tipo_comissao / intermediador
  corretor: "Corretor",
  imobiliaria: "Imobiliária",
  // clausula_garantia
  caucao: "Caução",
  fiador: "Fiador",
};
